import styled from "styled-components";
import { colours } from "../../../../styles/colours.constants";
import { satoshi500, satoshi700 } from "../../../../styles/font.constants";

type FormationsModuleStyleProps = {
	$withPadding: boolean;
};

export const FormationsModule = styled.div<FormationsModuleStyleProps>`
	width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	margin-top: ${({ $withPadding }) => ($withPadding ? "2rem" : 0)};
`;

export const TeamDetailsRow = styled.div<{ $isViewer: boolean }>`
	display: flex;
	justify-content: space-between;
	width: 100%;
	padding: 0 ${({ $isViewer }) => ($isViewer ? "1rem" : "2rem")};
`;

export const TeamInfo = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 0.4rem;
`;

export const InfoValue = styled.div`
	${satoshi700}
	color: ${colours.black};
	font-size: 1rem;
	text-transform: uppercase;
`;

export const InfoTitle = styled.div`
	${satoshi500}
	color: ${colours.greyDarker};
	font-size: 0.75rem;
	text-transform: uppercase;
`;
